import { http } from '@pendo/http';

export function fetchSegmentFlags () {
    return http.get('/api/s/_SID_/segmentflag').then((res) => res.data);
}
